import React, { useRef } from 'react';
import { ThemeProvider, GlobalStyle } from '@sparebankenvest/splash-ui';
import { Provider } from 'react-redux';
import styled from 'styled-components';
import CalculatorComponent from './CalculatorComponent';
import configureStore from './configureStore';

const store = configureStore();

const sitecoreId = 'senior-calc-sitecore';

const Wrapper = styled.section`
   background: #F6F6F6;
   color: #6C6C6C;
 `;

function Calculator() {
  const wrapperRef = useRef(null);
  const callbackSize = () => {
    const height = wrapperRef.current.offsetHeight;
    const msgData = { name: 'Kalkulator', height, key: sitecoreId };
    const msgDataAsJson = JSON.stringify(msgData);
    window.parent && window.parent.postMessage(msgDataAsJson, '*'); // window.parent i tilfelle ikke iframe
  };
  return (
    <Wrapper ref={wrapperRef} >
      <ThemeProvider>
        <GlobalStyle />
        <div className="Kalkulator">
          <Provider store={store}>
            <CalculatorComponent callbackSize={callbackSize} />
          </Provider>
          </div>
      </ThemeProvider>
    </Wrapper>
    );
}

export default Calculator;